import { httpApi } from 'core/httpApi';

export type IGetCountryResponse = {
    isEu: boolean;
    country: string;
};

export const getCountry = async () =>
    httpApi.v2.get<IGetCountryResponse, IGetCountryResponse>('geo/country');
